<div class="app-page">
  @if (this._flowitems!=null && this._flowitems.length==0) {
    <div style="font-family: Roboto; margin: 20px;;">
      NO ITEMS FOUND
    </div>
  }
  <div style="display: flex; flex-flow: row wrap; justify-content: center; ">
    @for (item of this._flowitems; track trackByFn($index, item)) {
      @if (item.FlowItemType=='SCREPORT') {
        <app-report-card  [Report]="item" ></app-report-card>
      }
      @if (item.FlowItemType=='PLAYERNOTE') {
        <app-note-card [Note]="item"></app-note-card>
      }
    }



  </div>

</div>
